@if (!editMode) {
  @if (loading) {
    <div class="tw:px-[15px] tw:py-3 tw:text-[13px] tw:text-[#888]">Loading ILP…</div>
  } @else if (ilp) {
    <div class="tw:px-[15px]">

      <!-- Header: date + status pill + open link -->
      <div class="tw:flex tw:flex-wrap tw:items-center tw:gap-3 tw:mb-4">
        <span class="tw:text-xs tw:text-[#888]">{{ ilp.date | date:'dd/MM/yyyy' }}</span>
        @if (statusLabel()) {
          <span class="badge badge-pill pr-status" [ngClass]="statusClass()">{{ statusLabel() }}</span>
        }
        <a class="tw:ml-auto tw:text-xs tw:font-semibold tw:text-[#4b3db5] tw:cursor-pointer" (click)="openIlp()">View / edit ILP</a>
      </div>

      <!-- Two-column: Academic | SEMH -->
      <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-6">

        <!-- Academic -->
        <div class="tw:flex tw:flex-col tw:gap-3">
          <div class="kvp__k kvp__k--heading">Academic assessment</div>

          <div class="kvp">
            <div class="kvp__k">Initial key stage:</div>
            <div class="kvp__v">{{ keyStageLabel() }}</div>
          </div>

          <div class="tw:flex tw:flex-col tw:gap-1">
            <span class="tw:text-xs tw:font-semibold tw:text-[#333]">Initial assessment score %</span>
            <leap-v2-scale-slider [value]="ilp.academic.initialScorePct" [min]="0" [max]="100"
                                  display="percent" [labels]="percentTicks" [disabled]="true">
            </leap-v2-scale-slider>
          </div>

          <div class="tw:flex tw:flex-col tw:gap-1">
            <span class="tw:text-xs tw:font-semibold tw:text-[#333]">Target assessment score %</span>
            <leap-v2-scale-slider [value]="ilp.academic.targetScorePct" [min]="0" [max]="100"
                                  display="percent" [labels]="percentTicks" [disabled]="true">
            </leap-v2-scale-slider>
          </div>

          <div class="kvp kvp--stacked">
            <div class="kvp__k kvp__k--heading">Assessment used:</div>
            <div class="kvp__v kvp__v--long-text">{{ ilp.academic.assessmentUsed }}</div>
          </div>
        </div>

        <!-- SEMH -->
        <div class="tw:flex tw:flex-col tw:gap-3">
          <div class="kvp__k kvp__k--heading">SEMH assessment</div>

          <div class="tw:flex tw:flex-col tw:gap-1">
            <span class="tw:text-xs tw:font-semibold tw:text-[#333]">Confidence</span>
            <leap-v2-scale-slider [value]="ilp.semh.confidence" [min]="semhMin" [max]="semhMax" [labels]="semhLabels" [colourRamp]="true" [disabled]="true"></leap-v2-scale-slider>
          </div>
          <div class="tw:flex tw:flex-col tw:gap-1">
            <span class="tw:text-xs tw:font-semibold tw:text-[#333]">Resilience</span>
            <leap-v2-scale-slider [value]="ilp.semh.resilience" [min]="semhMin" [max]="semhMax" [labels]="semhLabels" [colourRamp]="true" [disabled]="true"></leap-v2-scale-slider>
          </div>
          <div class="tw:flex tw:flex-col tw:gap-1">
            <span class="tw:text-xs tw:font-semibold tw:text-[#333]">Independence</span>
            <leap-v2-scale-slider [value]="ilp.semh.independence" [min]="semhMin" [max]="semhMax" [labels]="semhLabels" [colourRamp]="true" [disabled]="true"></leap-v2-scale-slider>
          </div>
          <div class="tw:flex tw:flex-col tw:gap-1">
            <span class="tw:text-xs tw:font-semibold tw:text-[#333]">Motivation</span>
            <leap-v2-scale-slider [value]="ilp.semh.motivation" [min]="semhMin" [max]="semhMax" [labels]="semhLabels" [colourRamp]="true" [disabled]="true"></leap-v2-scale-slider>
          </div>
          <div class="tw:flex tw:flex-col tw:gap-1">
            <span class="tw:text-xs tw:font-semibold tw:text-[#333]">Self-regulation</span>
            <leap-v2-scale-slider [value]="ilp.semh.selfRegulation" [min]="semhMin" [max]="semhMax" [labels]="semhLabels" [colourRamp]="true" [disabled]="true"></leap-v2-scale-slider>
          </div>
        </div>

      </div><!-- /two-column -->

      <!-- Areas + plan -->
      <div class="tw:mt-5 tw:flex tw:flex-col tw:gap-4">
        <div class="kvp kvp--stacked">
          <div class="kvp__k kvp__k--heading">Areas of strength:</div>
          <div class="kvp__v kvp__v--long-text">{{ ilp.areasOfStrength }}</div>
        </div>
        <div class="kvp kvp--stacked">
          <div class="kvp__k kvp__k--heading">Areas for development:</div>
          <div class="kvp__v kvp__v--long-text">{{ ilp.areasForDevelopment }}</div>
        </div>
        <div class="kvp kvp--stacked">
          <div class="kvp__k kvp__k--heading">Plan to achieve progress over the first six weeks:</div>
          <div class="kvp__v kvp__v--long-text">{{ ilp.planForProgress }}</div>
        </div>
        <div class="kvp">
          <div class="kvp__k">Evidence:</div>
          <div class="kvp__v">
            <!-- Each document opens through the API, which checks the caller may see it. -->
            @for (f of ilp.evidence; track $index) {
              <a class="ilp-evidence tw:block" href="" (click)="openEvidence($event, f)">{{ f.name }}</a>
            } @empty {
              None
            }
          </div>
        </div>
      </div>

    </div>
  }
}
